function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Button, PageEmptyState } from 'seagull';
import { Plus } from 'seagull/icons';
import { openInNewTabProps } from "../../../constants";
import { useStoreActions } from "../../../contexts";
import { helpArticles } from "../../../utils/helpArticles";
import { CommonServicesPage } from "../CommonServicesPage/CommonServicesPage";
import { ColumnId } from "../CommonServicesPage/CommonServicesPage.utils";
import EmptyServices from "../emptyServices.svg";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const baseColumnDefs = [{
  width: [200, 300],
  sortable: true
},
// service name
{
  width: [200, 400],
  sortable: false
},
// Included Services
{
  width: 120,
  sortable: true
},
// Occurance
{
  width: 110,
  sortable: true
} // Billing trigger
];
const baseHeaderItems = [{
  value: 'Service name',
  id: ColumnId.Name
}, {
  value: 'Included Services',
  id: ColumnId.IncludedServices
}, {
  value: 'Occurrence',
  id: ColumnId.BillingOccurance
}, {
  value: 'Billing trigger',
  id: ColumnId.BillingTrigger
}];
export function BundlesPage() {
  const {
    fetchBundles
  } = useStoreActions();
  const renderHeaderActions = _ref => {
    let {
      openBuilder
    } = _ref;
    return /*#__PURE__*/_jsx(Button, {
      prefixIcon: /*#__PURE__*/_jsx(Plus, {
        height: 18,
        width: 18
      }),
      "data-testid": "bundles-page-create-btn",
      onClick: () => openBuilder(),
      children: "Create Bundle"
    });
  };
  const renderEmptyState = _ref2 => {
    let {
      openBuilder
    } = _ref2;
    return /*#__PURE__*/_jsx(PageEmptyState, {
      "data-testid": "bundles-empty",
      illustration: /*#__PURE__*/_jsx(EmptyServices, {}),
      title: "Elevate Your Offering with Bundles",
      message: "Group multiple services into a single-priced bundle.",
      actions: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Button, {
          "data-testid": "bundles-page-new-btn",
          onClick: () => openBuilder(),
          children: "Create Bundle"
        }), /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({}, openInNewTabProps), {}, {
          skin: "primaryOutline",
          "data-testid": "bundles-learn-more-btn",
          as: "a",
          href: helpArticles.bundles(),
          children: "Learn more about Bundles"
        }))]
      })
    });
  };
  return /*#__PURE__*/_jsx(CommonServicesPage, {
    title: "Bundles",
    columnDefs: baseColumnDefs,
    headerItems: baseHeaderItems,
    fetchMethod: fetchBundles,
    renderEmptyState: renderEmptyState,
    headerActions: renderHeaderActions,
    dataSelector: state => state.bundles,
    bundlesMode: true
  });
}